<template lang="pug">
  //- video-image-slider(data-api-url="/api/bannerlist/aboutpage")
  .relative.preview
    .absolute.overlay.text-white(flex="row align-center justify-center")
      div
        h1.text-white.text-uppercase Global#[br] Footprint
        .lead
          span Silicon Valley
          span Los Angeles
          span Hawaii
        .lead
          span Hong Kong 
          span Beijing
          span Shanghai 
          span Shenzhen 
        .lead
          span Singapore 
          span Tokyo 
          span Seoul 
          span Taiwan
        .lead
          span London 
          span Paris 
          span Brussels 
          span Tel Aviv
    img.img-responsive(:src="coverUrl | img")

  section#profile.text-center
    .sm-container
      h1 {{'PROFILE_HEAD' | wordDict}}
      p.section_desc {{{'PROFILE_DESC' | wordDict | markdown}}}

  section#timeline
    iframe(src='https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1ADwTRJap8j1ScmpbMYkmOrUCAqz6KZYGQo9UoxMFHis&font=Default&lang=en&initial_zoom=2&height=650', width='100%', height='650', frameborder='0', |iframe='')
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      coverUrl: null,
    }
  },
  computed: {},
  ready () {
    axios.get('/api/bannerlist/aboutpage')
      .then(response => {
        this.coverUrl = response.data.result? response.data.result.photos[0].url: null
      })
  },
  attached () {},
  methods: {},
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "global";

.preview {
  .overlay {
    background-color: rgba(38, 87, 127, 0.5);
    height: 100%;
    min-width: 50%;
    width: 600px;
    max-width: 100%;
    > {
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
    h1 { margin-bottom: 30px; }
    img { width: 100%; }
    .lead {
      margin-bottom: 0;
      span:not(:last-child):after {
        content: '|';
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        @media (max-width: 500px) {
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }
    
    @media (max-width: $grid-float-breakpoint-max) {
      width: 100%;
      h1 {
        font-size: 30px;
        margin-bottom: 10px;
      }
    }
  }
}


@media (max-width: $grid-float-breakpoint-max) {
  section {
    padding: 16px;
    &:not(:first-child) {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 16px;
    }
  }
}
#profile {
  h1 {
    font-weight: bold;
    text-transform: uppercase;
    font-weight: 600;
  }
  @media(max-width: $grid-float-breakpoint-max) {
    h1 {
      font-size: 18px;
      letter-spacing: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// profile.vue?52167cdc